(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'emotion', '../elements'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('emotion'), require('../elements'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.emotion, global.elements);
    global.Badge = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _emotion, _elements) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var React = _interopRequireWildcard(_react);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    display: inline-block;\n    padding: 0.125rem 0.25rem;\n    background-color: ', ';\n    border-radius: 10px;\n    margin-left: 0.25rem;\n    font-weight: normal;\n    margin-top: -0.125rem;\n    margin-bottom: -0.125rem;\n  '], ['\n    display: inline-block;\n    padding: 0.125rem 0.25rem;\n    background-color: ', ';\n    border-radius: 10px;\n    margin-left: 0.25rem;\n    font-weight: normal;\n    margin-top: -0.125rem;\n    margin-bottom: -0.125rem;\n  ']);

  var Note = _elements.typography.Note;


  var Badge = function Badge(_ref) {
    var color = _ref.color,
        children = _ref.children;
    return React.createElement(
      Note,
      { className: classNames.badge(color) },
      children
    );
  };

  var classNames = {
    badge: function badge(color) {
      return (0, _emotion.css)(_templateObject, color);
    }
  };

  Badge.defaultProps = {
    color: '#c5e8c9' // Some variation on mint
  };

  exports.default = Badge;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Badge.js
// module id = 2021
// module chunks = 1